import { render } from "./NewsRoom.html?vue&type=template&id=c660725e&scoped=true&ts=true&external"
import script from "./NewsRoom.ts?vue&type=script&lang=ts&external"
export * from "./NewsRoom.ts?vue&type=script&lang=ts&external"

import "./NewsRoom.scss?vue&type=style&index=0&id=c660725e&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c660725e"]])

export default __exports__